import { Container } from 'react-bootstrap';
import { Button } from '../../atoms';
import { CustomDropdown } from '../../molecules';
import React, { FC, useState } from 'react';
import styles from './TranslationOrganism.module.css';
import { DropdownItem } from '../../molecules/CustomDropdown/CustomDropdown';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { GenerateTranslationModal } from '../index';
import { PromiseSettledResult } from '../../../utils/types/types';

interface TranslationOrganismProps {
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const TranslationOrganism: FC<TranslationOrganismProps> = ({
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const [openModal, setOpenModal] = useState(false);

  const languages: DropdownItem[] = Object.keys(LocalesLanguagesConstants).map(
    (key) => {
      return {
        label:
          LocalesLanguagesConstants[
            key as keyof typeof LocalesLanguagesConstants
          ],
        eventKey: key,
      };
    }
  );

  return (
    <div className={styles.translation}>
      <Container className={styles.translationContainer}>
        <div className={styles.translationDropDown}>
          <label>Language</label>
          <CustomDropdown
            initialTitle={
              languages.find((i) => i.label === selectedLanguage)!.label
            }
            items={languages}
            onSelectOption={(item) => {
              setLanguage(
                LocalesLanguagesConstants[
                  item.eventKey as keyof typeof LocalesLanguagesConstants
                ]
              );
            }}
          />
        </div>
        <Button variant="dark" onClick={() => setOpenModal(true)}>
          Generate Translation
        </Button>
      </Container>
      {openModal && (
        <GenerateTranslationModal
          show={openModal}
          setShow={setOpenModal}
          fromLanguage={fromLanguage}
          setFromLanguage={setFromLanguage}
          toLanguage={toLanguage}
          setToLanguage={setToLanguage}
          generateTranslation={generateTranslation}
          generateAllTranslations={generateAllTranslations}
        />
      )}
    </div>
  );
};

export default TranslationOrganism;
